export const profileENUM = {
    GENERATOR: "scrap-generator",
    ADMIN_BOSCH: "admin-bosch",
  };
  